
import ReactDOM from 'react-dom';
import { useEffect, useState } from "react";
import {AppLink as Link, AppWrapper, SeoPages, AppPages, AppLink} from "../components/helpers";
import app from "../components/app";
import Editor from "./editor";
import Preview from "./preview";
import {addNewProperty} from "./masterBlocks"


const copyClipboard = function(copyText) {
    var input = document.createElement("input");
    input.value = copyText;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    alert("Copied: " + copyText);
}

const openPopup = function(data, callback){
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<AppPages data={data} callback={callback} />, div);
}

const seoPopup = function(data, callback){
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<SeoPages data={data} callback={callback} />, div);
}

export default function Pages(props) {
    const [data, setData] = useState([]);
    const [item, setItem] = useState(null);
    const [page, setPage] = useState("");
    const [type, setType] = useState("");
    const config = app.getConfig();
    
    useEffect(() => {
        if(props.category) {
            app.fetchPost({
                "method":"getAllPages",
                "lang":"en"
            }).then(function(response){
                let itemData = null;
                if(response.data) {
                    response.data.forEach(function(v){
                        if(v.id === props.category) {
                            itemData = JSON.parse(JSON.stringify(v))
                        }
                    });
                    if(itemData) {
                        itemData["data"] = JSON.parse(itemData["data"]);
                        // itemData["data"] = itemData["data"].map(function(v, i){
                        //    // if(v.widgetType == "website_one"){
                        //         return addNewProperty(v)
                        //     // } 
                        //     // return v
                        //  })
                        itemData["dynamicAIData"] = itemData["data"];
                        setItem(itemData);
                    }
                }
            })
        }
        else {
            app.fetchPost({
                "method":"getAllPages",
                "lang":"en"
            }).then(function(response){
                if(response.data) {
                    setData(response.data);
                }
            })
        }
    }, [props.category]);

    const updateItem = function(key, value) {
        let itemData = JSON.parse(JSON.stringify(item));
        itemData[key] = value;
        setItem(itemData);
    }

    const saveItem = function(item, mode) {
        app.fetchPost({
            "method":"savePages",
            "id":item.id,
            "title":item.title,
            "page":item.page,
            "category":item.category,
            "status":true,
            "data":JSON.stringify(item.data)
        }, mode).then(function(response){
            if(!item.id) {
                if(response.data._id) {
                    window.pushState("pages", response.data._id);
                }
                else {
                    //window.location.reload();
                }
            }
          //  console.log("response", response);
        })
    }
    
    const seoItem = function(index) {
        app.getPage(data[index].id, function(response){
            seoPopup(response, function(response){
              //  console.log(response);
            })
        })
    }

    let html = <div className="w-100 p-2">
    <button className="btn btn-lg btn-outline-success" onClick={() => openPopup(null, saveItem)}>Add Page</button>
    </div>
    if(props.subcategory) {
        if(props.subcategory === "preview") {
            return <Preview type="pages" id={props.category} />
        }
        html = <div className="w-100 p-2">No Preview Found</div>
    }
    else if(props.category) {
        if(item) {
            return <Editor data={item} type="pages" callback={function(value, mode){
                let itemData = JSON.parse(JSON.stringify(item));
                itemData["data"] = value.dynamicAIData;
                saveItem(itemData, mode);
            }} />
        }
        html = <div className="w-100 p-2">Loading</div>
    }
    else {
        if(data.length) {
            html = <div className="container pages-container p-0">
                
            <div className="row">
                {
                    data.map(function(v, i){
                        let status = <span className="badge bg-danger">inactive</span>
                        if(v.status) {
                            status = <span className="badge bg-success">active</span>
                        }
                        let heading = "no heading";
                        if(v.heading === "0") {
                            heading = "no heading";
                        }
                        if(v.heading === 0) {
                            heading = "no heading";
                        }
                        if(v.heading) {
                            heading = v.heading;
                        }

                        if(page !== "") {
                            if(page !== v.page) {
                                return false;
                            }
                        }
                        if(type !== "") {
                            if(type !== v.category) {
                                return false;
                            }
                        }

                        return  <div className="col-3 mb-4" key={`page-${i}`}>
                        <div className="card w-100">
                        <img src={`${window.aiHost}/images/image-1x1.png`} className="card-img-top" alt="..." style={{backgroundImage:`url(https://media.mediadirhub.com/layouts/website/en/${v.id}.png)`}} />
                        <div className="card-body">
                            <h5 className="card-title">{v.title}</h5>
                            <div className="d-none">
                                SEO Category : <span className="badge bg-secondary me-1">{v.seocategory}</span></div>
                            <div style={{opacity:"0.4", userSelect:"none"}}>
                                <span className="badge bg-secondary me-1">{v.category}</span> 
                                {status}
                            </div>
                        </div>
                        <div className="card-footer p-2">
                        <div className="input-group input-group-sm">
                    <span className="input-group-text w-75">{v.id}</span>
  <button className="btn btn-secondary w-25" type="button" onClick={() => copyClipboard(v.id)}>copy</button>

</div>
                            <button className="btn btn-sm btn-secondary m-1 d-none" onClick={() => seoItem(i)}>Edit</button>
                        </div>
                        </div>
                    </div>
                    })
                }
            </div>
            <div className="w-100 p-2 d-none">
    <button className="btn btn-lg btn-outline-success" onClick={() => openPopup(null, saveItem)}>Add Page</button>
    </div>
            </div>
        }
        
    }
    return  <div className="container-fluid p-0 w-100 h-100">
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container-fluid">
  <AppLink className="navbar-brand" href="/">AI Editor</AppLink>
  <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
  <span className="navbar-toggler-icon"></span>
  </button>
  <div className="collapse navbar-collapse">
  <ul className="navbar-nav me-auto mb-2 mb-lg-0">
   
  </ul>
 
  </div>
  </div>
  </nav>
  <div className="container-fluid p-0 w-100 overflow-scroll" style={{height:"calc(100% - 56px)"}}>
  <div className="w-100 p-1">
            <span className="me-3"><b>Page</b> </span>
           
        {
            ["all", ...config.pages].map(function(v, i){
                let active = "";
                if(page === "") {
                    if(i === 0) {
                        active = "active";
                    }
                }
                else {
                    if(v === page) {
                        active = "active";
                    }
                }
                return <a className={`btn btn-outline-secondary btn-sm m-1 ${active}`} onClick={() => setPage(v === "all"?"":v)}>{v}</a>
            })
        }
        </div>
        <div className="w-100 p-1">
            <span className="me-3"><b>Category</b> </span>
            {
            ["all", ...config.categories.map(function(v){
                return v.folder;
            }), ...config.newCategories.map(function(v){
                return v.slug;
            })].map(function(v, i){
                let active = "";
                if(type === "") {
                    if(i === 0) {
                        active = "active";
                    }
                }
                else {
                    if(v === type) {
                        active = "active";
                    }
                }
                return <a className={`btn btn-outline-secondary btn-sm m-1 ${active}`} onClick={() => setType(v === "all"?"":v)}>{v}</a>
            })
        }
            
        </div>
    {html}
  </div>
  </div>
}